<template>

    <div class="v-application v-application--is-ltr theme--light">

        <v-card elevation="24">

            <v-card-title class="text-h6">
                {{ title || 'Update' }}
            </v-card-title>

            <v-card-text v-if="message">
                {{ message || 'Are you sure that you would like to perform this action?' }}
            </v-card-text>
            <div class="modal-create-data-section edit-date-input-section">
                <div class="modal-create-data-item">
                    <p>First Name</p>
                    <input ref="firstName" class="visitor-modal-title" v-model="firstName" />
                </div>
                <div class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Last Name</p>
                    <input ref="lastName" class="visitor-modal-title" v-model="lastName" />
                </div>
                <div ref="email" class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Email</p>
                    <input class="visitor-modal-title" v-model="email" />
                </div>
                <div ref="phone" class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Phone Number</p>
                    <input class="visitor-modal-title" v-model="phone" />
                </div>
                <div class="modal-create-data-item" style="margin-top: 8px;">
                    <p>Role</p>
                    <div @mouseleave="showRoles = false" style="flex:2; z-index: 2; display: flex;" ref="residentData">
                        <option-dropdown-select v-if="showRoles" class="search" style="top: 36px" :options="roles"
                            :openUpwards="true" :onOptionSelected="(option, event) => {
                                event.stopImmediatePropagation()
                                role = option.value;
                                showRoles = false
                            }" />
                        <button v-else class="option-select-dropdown-button"
                            style="flex: 2; display: flex; align-items: center; justify-content: center;">
                            <div style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                                @mousedown="showRoles = !showRoles">
                                <p style="text-align: center; margin-left: 8px;" @mousedown="showRoles = !showRoles">
                                    {{ roleDisplay }}</p>
                                <div style="padding-right: 8px; font-weight: bolder;">
                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                                        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            <v-card-text v-if="disclaimer" style="color: black; padding-top: 0px;">
                {{ disclaimer || 'By selecting Confirm, you are authorizing this action to be taken' }}
            </v-card-text>

            <v-card-text v-if="changeList" style="color: black; padding-top: 0px;">
                {{ changeList }}
            </v-card-text>

            <v-card-actions>
                <v-btn color="primary" @click="confirm">
                    {{ confirmText || 'Confirm' }}
                </v-btn>
                <v-btn color="red" text @click="close">
                    {{ cancelText || 'Cancel' }}
                </v-btn>
            </v-card-actions>

        </v-card>

    </div>

</template>

<script>
import OptionDropdownSelect from '../../layout/OptionDropdownSelect.vue';
import * as Utils from '../../../js/Utils'
export default {
    props: ["title", "message", "disclaimer", "cancelText", "confirmText", "onConfirm", "userData"],
    components: {
        OptionDropdownSelect,
    },
    data() {
        return {
            firstName: this.$props.userData.first_name,
            lastName: this.$props.userData.last_name,
            email: this.$props.userData.primary_email_address,
            phone: this.$props.userData.primary_phone_number,
            role: this.$props.userData.role,
            showRoles: false,
            roles: [
                { name: "Admin", value: "admin" },
                { name: "HOA Admin", value: "hoa_admin" },
                { name: "Guard", value: "guard" },
                { name: "Resident", value: "resident" },
                { name: "Secondary User", value: "secondary_user" },
            ]
        }
    },
    watch: {
        email(newVal) {
            if (Utils.isValidEmail(newVal)) {
                this.$refs['email'].classList.remove('invalid')
            } else {
                this.$refs['email'].classList.add('invalid')
            }
        },
        phone(newVal) {
            if (Utils.isValidPhoneNumber(newVal)) {
                this.$refs['phone'].classList.remove('invalid')
            } else {
                this.$refs['phone'].classList.add('invalid')
            }
        }
    },
    computed: {
        changeList() {
            let changeList = []
            const inputData = this.$props.userData
            if (this.firstName != inputData.first_name) {
                changeList.push("First Name")
            }
            if (this.lastName != inputData.last_name) {
                changeList.push("Last Name")
            }
            if (this.email != inputData.primary_email_address) {
                changeList.push("Email")
            }
            if (this.phone != inputData.primary_phone_number) {
                changeList.push("Phone Number")
            }
            if (this.role != inputData.role) {
                changeList.push("Role")
            }
            if (changeList.length < 1) {
                return ""
            }
            return `Changes: ${changeList.join(", ")}`
        },
        roleDisplay() {
            return this.$roleNameMap[this.role]
        }

    },
    methods: {

        close() {
            this.$emit('close');
        },
        validateInputs() {
            let missingData = []
            // Email
            if (!Utils.isValidEmail(this.email)) {
                missingData.push("Email is incorrectly formatted, please format as email@provider.com")
            }
            // Phone
            if (!Utils.isValidPhoneNumber(this.phone)) {
                missingData.push("Phone Number is incorrectly formatted, please format as +19991234567")
            }
            if (missingData.length > 0) {
                alert(missingData.join('\n'))
                return false
            } else {
                return true
            }
        },
        async confirm() {
            if (!this.validateInputs()) {
                return;
            }
            if (!this.onConfirm) {
                this.close();
                return;
            }
            const preservedValues = [
                'address',
                'secondary_email_address',
                'secondary_phone_number',
                'subdivision',
                'current_status',
            ]
            const constructedData = {
                'first_name': this.firstName,
                'last_name': this.lastName,
                'address': '',
                'primary_email_address': this.email,
                'secondary_email_address': '',
                'primary_phone_number': this.phone,
                'secondary_phone_number': '',
                'subdivision': '',
                'role': this.role,
                'current_status': ""
            }
            for (const key of Object.keys(constructedData)) {
                if (constructedData[key] == this.$props.userData[key] || constructedData[key] == "") {
                    constructedData[key] = ""
                    preservedValues.push(key)
                }
            }
            console.log("Preserved Values", preservedValues)
            console.log("Constructed Data Keys", Object.keys(constructedData))
            if (preservedValues.length == Object.keys(constructedData).length) {
                this.close();
                return;
            }
            await this.onConfirm(constructedData);
            this.close();
        },
    }

};
</script>

<style scoped>
.vuetify-modal-wrapper {
    background: transparent;
}

.edit-date-input-section {
    padding-left: 1em;
    padding-right: 1em;
    padding-bottom: 1em;
}
</style>